import type { TemplateAssignmentScope } from '@Application/Documents/TemplateAssignments/TemplateAssignmentScope';

class FetchTemplateAssignments {
	constructor(public readonly scope: TemplateAssignmentScope) {
		Object.freeze(this);
	}
}

export default FetchTemplateAssignments;
